import Form from '../detail/detail.vue';

export default {
  components: {
    badgeForm: Form
  },

  data() {
    return {
      badges: [],
      editing: false,
      editingBadge: null,
      courseId: null,
      page: null
    };
  },

  mounted() {
    this.courseId = Kadenze.Util.getCourseIdFromPath();
  },

  methods: {
    bindData(badges, page) {
      this.badges = badges;
      this.page = page || 1;
    },

    addNew() {
      this.editingBadge = null;
      this.editing = true;
    },

    edit(badge) {
      this.editingBadge = badge;
      this.editing = true;
    },

    destroy(badge) {
      Kadenze.Ajax.delete({
        routeName: 'course_badge',
        routeParams: [this.courseId, badge.id],
        loadingIndicator: true,
        success: () => this.reloadBadges()
      });
    },

    reloadBadges() {
      Kadenze.Ajax.get({
        routeName: 'course_badges',
        routeParams: [this.courseId, { page: this.page }],
        loadingIndicator: true,
        success: resp => this.badges = resp
      });
    }
  }
};
